var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-row',[_c('w-col',{attrs:{"xs":"12"}},[_c('app-select-bank-type',{attrs:{"fancy":"","label":_vm.label,"value":_vm.val,"use-ids":""},on:{"input":function($event){return _vm.onInput($event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }